<template>
  <grid-container
    :class="['search', small && 'search-small']"
    :cols="`minmax(140px, auto) ${small ? '48px' : '55px'}`"
  >
    <v-text-field
      v-model="q"
      @keyup.enter="search"
      class="rounded-0 grey lighten-4 text-body-2"
      color="grey darken-2"
      background-color="white"
      label="Buscar"
      type="search"
      dense
      hide-details
      :outlined="!small"
      :solo="small"
      flat
      clearable
      clear-icon="fas fa-times"
    ></v-text-field>
    <v-btn
      @click="search"
      :color="small ? 'primary' : 'grey'"
      height="40px"
      width="40px"
      min-width="40px"
      tile
      depressed
      :outlined="!small"
    >
      <v-icon :size="small ? 22 : 19">fas fa-search </v-icon>
    </v-btn>
  </grid-container>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    q: "",
  }),
  methods: {
    search() {
      if (this.q) this.$router.push(`/noticias?q=${this.q}`);
    },
  },
};
</script>

<style>
.search:not(.search-small) .v-label {
  font-size: 14px !important;
}
</style>
